import { FIELD_ID } from '../components/CustomCode/AAG/aag_constants'
import { makeInteger } from '../utils'

const mrg = {
  validation_hook: async function validation_hook(fieldInput, objectId, formInputs) {
    console.log('document_model.validation_hook', fieldInput, objectId, formInputs)

    function getFieldValue(fieldId) {
      return formInputs[fieldId].currentValue
    }

    let validationMessage = ''
    switch (makeInteger(fieldInput.field.id)) {
      case FIELD_ID.casePlaintiff.worker:
        const worker = getFieldValue(FIELD_ID.casePlaintiff.worker)
        const namedPlaintiff = getFieldValue(FIELD_ID.casePlaintiff.namedPlaintiff)
        const derivativePlaintiff = getFieldValue(FIELD_ID.casePlaintiff.derivativePlaintiff)
        if (worker === 'N' && namedPlaintiff === 'N' && derivativePlaintiff === 'N') {
          validationMessage = 'Worker, Named Plaintiff, and Derivative Plainitiff cannot all be set to "No".'
        }
        break
      default:
        validationMessage = ''
    }
    console.log('validationMessage: ', validationMessage)
    return validationMessage
  }
}

export default mrg